import QCheckboxGroup from './src/QCheckboxGroup.vue';

/* istanbul ignore next */
QCheckboxGroup.install = function(Vue) {
  Vue.component(QCheckboxGroup.name, QCheckboxGroup);
};

export default QCheckboxGroup;
